var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineHeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08824 11.1429C6.08824 10.9259 6.25942 10.75 6.47059 10.75H14.1176C14.3288 10.75 14.5 10.9259 14.5 11.1429C14.5 11.3598 14.3288 11.5357 14.1176 11.5357H6.47059C6.25942 11.5357 6.08824 11.3598 6.08824 11.1429Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08824 8C6.08824 7.78303 6.25942 7.60714 6.47059 7.60714H14.1176C14.3288 7.60714 14.5 7.78303 14.5 8C14.5 8.21697 14.3288 8.39286 14.1176 8.39286H6.47059C6.25942 8.39286 6.08824 8.21697 6.08824 8Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08824 4.85714C6.08824 4.64017 6.25942 4.46429 6.47059 4.46429H14.1176C14.3288 4.46429 14.5 4.64017 14.5 4.85714C14.5 5.07411 14.3288 5.25 14.1176 5.25H6.47059C6.25942 5.25 6.08824 5.07411 6.08824 4.85714Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68213 13.3849C3.53281 13.5384 3.29072 13.5384 3.1414 13.3849L1.61199 11.8135C1.46267 11.6601 1.46267 11.4113 1.61199 11.2579C1.76131 11.1045 2.0034 11.1045 2.15272 11.2579L3.02941 12.1587L3.02941 3.8413L2.15272 4.74208C2.0034 4.8955 1.76131 4.8955 1.61199 4.74208C1.46267 4.58866 1.46267 4.33991 1.61199 4.18649L3.1414 2.61507C3.29072 2.46164 3.53281 2.46164 3.68213 2.61507L5.21154 4.18649C5.36086 4.33991 5.36086 4.58866 5.21154 4.74208C5.06222 4.8955 4.82013 4.8955 4.67081 4.74208L3.79412 3.8413L3.79412 12.1587L4.67081 11.2579C4.82013 11.1045 5.06222 11.1045 5.21154 11.2579C5.36086 11.4113 5.36086 11.6601 5.21154 11.8135L3.68213 13.3849Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineHeightIcon);
export default __webpack_public_path__ + "static/media/LineHeightIcon.f0679225b468a9a2efa8df9f6e4c509f.svg";
export { ForwardRef as ReactComponent };